const GET_COUNTRIES = "GET_COUNTRIES";

const GET_COUNTRIES_SUCCESS = "GET_COUNTRIES_SUCCESS";
const GET_COUNTRIES_FAIL = "GET_COUNTRIES_FAIL";

const UPDATE_COUNTRIES = "UPDATE_COUNTRIES";

const BASE_ENDPOINT = "/MasterData";
const initialValues = {
  loading: false,
  hasError: false,
  data:[]
};

const countries = (state = initialValues, action) => {
  switch (action.type) {
    case GET_COUNTRIES: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_COUNTRIES_SUCCESS: {
      action.payload.data=action.payload.data.map(({id,name,longName,validateXmlInvoice})=>{
        return {
          id,
          name,
          longName,
          validateXmlInvoice,
          selected:false
        }
      })
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      };
    }

    case GET_COUNTRIES_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }
   
    case UPDATE_COUNTRIES: {
      return {
        ...state,
        data:action.payload,
        loading: false,
      };
    }
    default: {
      return state;
    }
  }
};

export const getCountries = () => {
  return {
    type: GET_COUNTRIES,
    payload: {
      request: {
        method: "GET",
        url: BASE_ENDPOINT + "/CountriesWithSocieties",
      },
    },
  };
};

export const updateCountriesSelected = (data) => {
  return {
    type: UPDATE_COUNTRIES,
    payload:data,    
  };
};
export default countries;
